<template>
  <div>
    <div class="px-2 mb-1">
      <v-row>
        <v-col class="mt-3" cols="3" v-for="(item, i) in deal_summary" :key="i">
          <v-card
            flat
            outlined
            class="pa-3 rounded-lg elevation-0 w-100 mr-3"
            :style="{ borderLeft: `.25rem solid ${item.color}` }"
          >
            <div
              class="text-h6 font-weight-medium mb-2"
              :style="{ color: `${item.color}` }"
            >
              {{ item.label }}
            </div>
            <div class="headline font-weight-bold">
              {{ item.value }}
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <h2
      class="d-flex justify-space-between margin-auto color-custom-blue font-weight-600"
    >
      <span>
        <v-icon color="#24326d">mdi-lightbulb-outline </v-icon>
        Opportunities
      </span>
      <v-btn
        small
        elevation="0"
        class="cyan text-white mr-2 custom-grey-border custom-bold-button"
      >
        <v-icon left small size="20">mdi-plus</v-icon>
        Add opportunity
      </v-btn>
    </h2>
    <v-row class="customer-detail custom-border-to">
      <v-col md="12" sm="12" class="pt-0 my-4">
        <v-skeleton-loader
          class="custom-skeleton"
          v-if="pageLoading"
          type="table-tbody"
        >
        </v-skeleton-loader>
        <div v-else class="overflow-x-auto">
          <v-simple-table
            class="simple-table border border-1"
            style="min-width: 1200px"
          >
            <template v-slot:default>
              <thead>
                <tr style="background-color: #f3f6f9; color: #24326d">
                  <td style="width: 60px !important">
                    <v-checkbox
                      v-model="selectedAll"
                      class="hide-margin py-0 my-0"
                      color="cyan"
                      dense
                      hide-details
                    ></v-checkbox>
                  </td>
                  <td
                    style="width: 60px !important"
                    class="font-size-13 text-uppercase font-weight-500"
                  >
                    Status
                  </td>
                  <td class="font-size-13 text-uppercase font-weight-500">
                    Source
                  </td>
                  <td class="font-size-13 text-uppercase font-weight-500">
                    Priority
                  </td>
                  <td class="font-size-13 text-uppercase font-weight-500">
                    Notes
                  </td>
                  <td class="font-size-13 text-uppercase font-weight-500">
                    Reminder
                  </td>
                  <td class="font-size-13 text-uppercase font-weight-500">
                    Contact Details
                  </td>
                  <td class="font-size-13 text-uppercase font-weight-500">
                    Amount
                  </td>
                  <td class="font-size-13 text-uppercase font-weight-500">
                    Last Contact
                  </td>
                  <td
                    class="font-size-13 text-uppercase text-center font-weight-500"
                  >
                    Actions
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(opportunity, index) in opportunities"
                  :key="index"
                  :class="{
                    'custom-border-top': index == 0,
                    'orange_lighten-5': index % 2 == 0,
                  }"
                  role="button"
                  tabindex="0"
                  style="cursor: pointer"
                  @click="onRowClick(opportunity, $event)"
                  @keydown.enter="onRowKey(opportunity, $event)"
                >
                  <td>
                    <v-checkbox
                      v-model="selectedAll"
                      class="hide-margin py-0 my-0"
                      color="cyan"
                      dense
                      hide-details
                    ></v-checkbox>
                  </td>
                  <td class="font-size-14">
                    <div style="width: 60px !important">
                      <v-switch
                        v-model="opportunity.status"
                        class="mt-0"
                        inset
                        color="green"
                      ></v-switch>
                    </div>
                  </td>
                  <td class="font-size-14 font-weight-500 text-lowercase">
                    <v-chip
                      v-if="opportunity.source"
                      label
                      small
                      outlined
                      color="#24326d"
                    >
                      {{ opportunity.source }}
                    </v-chip>
                  </td>
                  <td class="font-size-14 font-weight-500">
                    <div
                      class="font-weight-bold text-uppercase"
                      v-if="opportunity.priority === 'High'"
                      style="color: red"
                    >
                      <v-chip
                        small
                        class="text-white px-2 py-1"
                        color="red lighten-1"
                      >
                        High
                      </v-chip>
                    </div>

                    <div
                      class="font-weight-bold text-uppercase"
                      v-else-if="opportunity.priority === 'Medium'"
                      style="color: skyblue"
                    >
                      <v-chip
                        small
                        class="text-white px-2 py-1"
                        color="orange lighten-1"
                      >
                        Medium
                      </v-chip>
                    </div>

                    <div
                      class="font-weight-bold text-uppercase"
                      v-else-if="opportunity.priority === 'Low'"
                      style="color: green"
                    >
                      <v-chip
                        small
                        class="text-white px-2 py-1"
                        color="green lighten-1"
                      >
                        Low
                      </v-chip>
                    </div>
                    <em v-else class="text-muted"> no Priority </em>
                  </td>
                  <td class="font-size-14 font-weight-500 text-lowercase">
                    <span class="line-climp-content-lead">
                      {{ opportunity.notes }}
                    </span>
                  </td>
                  <td class="font-size-14 font-weight-500 text-lowercase">
                    <div v-if="opportunity.reminder">
                      {{ opportunity.reminder }}
                    </div>
                    <em v-else class="text-muted"> no opportunity </em>
                  </td>
                  <td class="font-size-14 font-weight-500 text-lowercase">
                    <div v-if="opportunity.contact">
                      <div>
                        <v-icon class="me-1" size="15">mdi-phone</v-icon
                        >{{ opportunity.contact.Ph }}
                      </div>
                    </div>
                    <em v-else class="text-muted"> no contact </em>
                  </td>
                  <td class="font-size-14 font-weight-500 text-lowercase">
                    <div v-if="opportunity.amount">
                      $ {{ opportunity.amount }}
                    </div>
                    <em v-else class="text-muted"> no amount</em>
                  </td>
                  <td class="font-size-14 font-weight-500 text-lowercase">
                    {{ opportunity.lastContact }}
                  </td>
                  <td class="font-size-14 font-weight-500 text-lowercase">
                    <v-btn small icon color="orange"
                      ><v-icon size="20">mdi-eye</v-icon></v-btn
                    >
                    <v-btn small icon color="green"
                      ><v-icon size="20">mdi-pencil</v-icon></v-btn
                    >
                    <v-btn small icon color="red"
                      ><v-icon size="20">mdi-delete</v-icon></v-btn
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    deal_summary: Array,
    opportunities: Array,
  },

  data() {
    return {};
  },

  methods: {
    selectOpportunity(param) {
      const id = param && param.id ? param.id : param;
      this.$emit("selectOpportunity", id);
    },
    onRowClick(opportunity, event) {
      const ignore = event.target.closest(
        "a, button, input, textarea, select, .v-btn, svg, path"
      );
      if (ignore) return;
      this.selectOpportunity(opportunity);
    },
    onRowKey(opportunity, event) {
      if (event.key === "Enter" || event.keyCode === 13) {
        this.selectOpportunity(opportunity);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
